module.exports = __webpack_public_path__ + "img/icon_index.fe0dd69b.svg";